import { useEffect, useRef, useState } from 'react'
import './carousel.css';
import ArticleCard from './ArticleCard';
import { debounce } from '../../../../utils/performance';
import Flickity from 'react-flickity-component';
import "../neatSlider/css/flickity.css";


const Carousel = ({data, title, setItemsToShow, itemsToShow}) => {

  const [carouselItems, setCarouselItems] = useState(data);

  const handleResize = debounce(() => {
    const winSize = window.innerWidth;
    if (winSize >= 1200) {
      return setItemsToShow(5);
    }
    if (winSize > 600) {
      return setItemsToShow(3);
    }
    return setItemsToShow(1);
  }, 2000);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
  }, []);

  const flickityOptions = {
    cellAlign: "left",
    initialIndex: 0,
    prevNextButtons: false,
    pageDots: true,
    wrapAround: false,
    groupCells: true, // groupCells: itemsToShow,
    pageDots: carouselItems.length > itemsToShow
}
  let cells = [];
  carouselItems.map((item) => cells.push(<ArticleCard style={{height: '100%', marginRight: '1%'}} key={item.id} 
        data={item}/>));

  return (
    <div className='ca-wrap'>
      <div className='ca-header'>
        <div className='ca-title'>{title || data[0]?.group?.name}</div>        
      </div>
          <Flickity
            className={"ca-container" + (carouselItems.length <= itemsToShow ? " no-slide" : "")} // default ''
            elementType={'div'} // default 'div'
            options={flickityOptions} // takes flickity options {}
            disableImagesLoaded={false} // default false
            reloadOnUpdate // default false
            static // default false
          >
              {cells}
          </Flickity>     
    </div>
  );
}

export default Carousel;